import { createSelector } from '@ngrx/store';

import { selectFehHomebatteryState } from '../feh-homebattery.state';

const wizardState = 'homebattery-wizard';

export const selectHomeBatteryConsumptionState = createSelector(
  selectFehHomebatteryState,
  (state) => state[wizardState].consumption
);

export const selectHomeBatteryFormDataState = createSelector(
  selectFehHomebatteryState,
  (state) => state[wizardState].formData
);

export const selectHomeBatteryConsumptionEstimateValueState = createSelector(
  selectFehHomebatteryState,
  (state) => state[wizardState].formData?.consumptionPerYear
);
